
import BaseTextSection from "@/components/base/BaseTextSection.vue";
import PartnersPhones from "@/components/partners/PartnersPhones.vue";
import PartnersPhoneText from "@/components/partners/PartnersPhoneText.vue";
import BaseAlbumScroll from "@/components/base/BaseAlbumScroll.vue";
import PartnersForm from "@/components/partners/PartnersForm.vue";

export default {
  components: {
    BaseTextSection,
    PartnersPhones,
    PartnersPhoneText,
    BaseAlbumScroll,
    PartnersForm
  },
  mounted() {
    // handle screen resize
    this.screenWidth = window.innerWidth
    window.addEventListener('resize', this.handleResize)
    // shuffle 3 images on first gallert
    this.shuffleImages()

    //if the url contains hash direct to form
    if (this.$route.hash && this.$route.hash === '#partners-form') {
      this.directToForm()
    }

  },
  data() {
    return {
      screenWidth: 0,
      bands: [
        {
          name: 'CITIBANAMEX',
          description: 'Con una estrategia always on, Citi Banamex logró conectar con las audiencias más jóvenes de TREBEL para mejorar la percepción de la marca e incrementar la intención de compra.',
          img: 'https://images.projectcarmen.com/resource/ads/65d72db1f38b14ec38046ea5.png',
          img_big: 'https://images.projectcarmen.com/resource/ads/65d39a516ff06b70a70ab4b9.png',
          img_small: 'https://images.projectcarmen.com/resource/ads/65d7417e6ff06b70a70abb63.png'
        },
        {
          name: 'MONDELEZ',
          description: 'A través de segmentaciones de audiencia a la medida -- definidas con first party data de TREBEL --, Philadelphia logró incrementar el tráfico a sus 5 principales plataformas de e-commerce en México.',
          img: 'https://images.projectcarmen.com/resource/ads/65d72da46ff06b70a70abb5b.png',
          img_big: 'https://images.projectcarmen.com/resource/ads/65d398ecf38b14ec38046871.png',
          img_small: 'https://images.projectcarmen.com/resource/ads/65d73cc65e6bf6531f09169c.png'
        },
        {
          name: 'BIMBO',
          description: 'Con la presencia de seis marcas dentro de TREBEL, Grupo Bimbo ejecutó una campaña de generación de leads que le permitió abrir un canal de comunicación directa con sus consumidores para entender mejor sobre sus gustos y preferencias.',
          img: 'https://images.projectcarmen.com/resource/ads/65d72d955e6bf6531f09169a.png',
          img_big: 'https://images.projectcarmen.com/resource/ads/65d39916f38b14ec38046873.png',
          img_small: 'https://images.projectcarmen.com/resource/ads/65d73cd56ff06b70a70abb5f.png'
        },
        {
          name: 'P&G',
          description: 'Ariel, Salvo, Downy, Head & Shoulders, Pantene y Gillette llegaron a TREBEL para quedarse después de obtener KPIs estelares en métricas clave como CTR’s y Completion Rates de video hasta 5X veces por encima de los promedios de la industria.',
          img: 'https://images.projectcarmen.com/resource/ads/65d72d88f38b14ec38046ea3.png',
          img_big: 'https://images.projectcarmen.com/resource/ads/65d399286ff06b70a70ab4b7.png',
          img_small: 'https://images.projectcarmen.com/resource/ads/65d73ceaf38b14ec38046ea9.png'
        },
        {
          name: 'OXXO',
          description: 'Con resultados de generación de tráfico que estuvieron 4X por encima de lo estimado, Oxxo ejecutó 25 campañas con TREBEL en 2023, aplicando segmentaciones a medida y descubriendo afinidades entre sus usuarios.',
          img: 'https://images.projectcarmen.com/resource/ads/65d72d796ff06b70a70abb59.png',
          img_big: 'https://images.projectcarmen.com/resource/ads/65d399395e6bf6531f090f3b.png',
          img_small: 'https://images.projectcarmen.com/resource/ads/65d73d005e6bf6531f09169e.png'
        },
        {
          name: 'Volkswagen',
          description: 'Basados en data propietaria de TREBEL obtenida a través de cuestionarios de perfilamiento progresivo, Volkswagen ejecutó campañas hiper segmentadas para promocionar sus distintos modelos considerando la intención de compra y el presupuesto a la hora de segmentar.',
          img: 'https://images.projectcarmen.com/resource/ads/65d72f866ff06b70a70abb5d.png',
          img_big: 'https://images.projectcarmen.com/resource/ads/65d72d185e6bf6531f091698.png',
          img_small: 'https://images.projectcarmen.com/resource/ads/65d73d106ff06b70a70abb61.png'
        },
      ],
      selectedBand: {},
      showBandModal: false,
      shuffleFirst: 'https://images.projectcarmen.com/resource/ads/65d30e1a6ff06b70a70ab37d.png',
      shuffleSecond: 'https://images.projectcarmen.com/resource/ads/65d30e325e6bf6531f090e26.png',
      shuffleThird: 'https://images.projectcarmen.com/resource/ads/65d30e91f38b14ec3804674a.png',
      interval: null
    }
  },
  computed: {
    paddingX() {
      return this.screenWidth < 768 ? '16px' : '10%';
    },
    paddingBottom() {
      return this.screenWidth < 768 ? '0' : '86';
    },
    phones() {
      return this.screenWidth < 600
          ? 'https://images.projectcarmen.com/resource/ads/65d3421e6ff06b70a70ab392.png'
          : 'https://images.projectcarmen.com/resource/ads/65d33d476ff06b70a70ab38a.png'
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    shuffleImages() {
      const first = ['https://images.projectcarmen.com/resource/ads/65d5e6376ff06b70a70ab919.png','https://images.projectcarmen.com/resource/ads/65d30e1a6ff06b70a70ab37d.png']
      const second = ['https://images.projectcarmen.com/resource/ads/65d5e686f38b14ec38046bc7.png', 'https://images.projectcarmen.com/resource/ads/65d30e325e6bf6531f090e26.png']
      const third = ['https://images.projectcarmen.com/resource/ads/65d5e6b15e6bf6531f0913a8.png','https://images.projectcarmen.com/resource/ads/65d30e91f38b14ec3804674a.png']
      this.interval = setInterval(() => {
        this.shuffleFirst = this.shuffleFirst === first[0] ? first[1] : first[0]
        this.shuffleSecond =  this.shuffleSecond === second[0] ? second[1] :second[0]
        this.shuffleThird = this.shuffleThird === third[0] ? third[1] : third[0]
      }, 5000)
    },
    handleResize() {
      this.screenWidth = window.innerWidth
    },
    showBand(index) {
      this.selectedBand = this.bands[index]
      this.showBandModal = !this.showBandModal
    },
    directToForm() {
      const targetDiv = document.getElementById('partners-form');
      if (targetDiv) {
        targetDiv.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    },
    downloadFile(locale) {
      const link = document.createElement('a');
      link.href = `/pdf/Radiografia_2025_TREBEL.pdf`;
      link.download = `Radiografia_2025_TREBEL.pdf`;
      link.click();
    }
  }
}
